import * as type from '../actions/types';

const initialState = {
  availablePeriods: null,
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_AVAILABLE_PERIODS_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case type.FETCH_AVAILABLE_PERIODS_SUCCESS:
      return {
        ...state,
        availablePeriods: action.payload,
        loading: false,
        error: null,
      };

    case type.FETCH_AVAILABLE_PERIODS_FAILURE:
      return {
        ...state,
        availablePeriods: state.availablePeriods,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
